// 处方详情 基本信息
import { momentFormat } from '@/utils'

const BASE_LABEL = [
  {
    label: '姓名',
    prop: 'patientName',
    nopadding: true,
    render: (val, record) => {
      return record?.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    label: '性别',
    prop: 'patientGender',
    render: (val, record) => {
      const gender = record?.patientProfileCommonVO?.gender
      return [0, 1].includes(gender) ? (gender === 0 ? '女' : '男') : '--'
    },
    nopadding: false
  },
  {
    label: '年龄',
    prop: 'patientAge',
    render: (val, record) => {
      const age = record?.patientProfileCommonVO?.age
      return age || age === 0 ? age + '岁' : '--'
    },
    nopadding: false,
    noborder: true
  },
  {
    label: '就诊诊断',
    prop: 'diagnosisInfoList',
    nopadding: true
  },
  {
    label: '处方药品',
    prop: 'spuNames',
    render: list => {
      if (!list || !list.length) return '--'
      return list.map(item => item).join('；')
    },
    nopadding: false
  },
  {
    label: '关联随访计划',
    prop: 'followupPlanIds',
    nopadding: false,
    noborder: true
  },
  {
    label: '开始时间',
    prop: 'purchaseTime',
    render: text => {
      return momentFormat(text)
    },
    nopadding: true
  },
  {
    label: '用药周期',
    prop: 'medicineCycle',
    render: v => {
      if (!v) return '--'
      return v + ' 天'
    },
    nopadding: false
  },
  {
    label: '结束时间',
    prop: 'calcEndDate',
    nopadding: false,
    noborder: true
  },
  {
    label: '病情描述',
    prop: 'description',
    class: 'large',
    nopadding: true,
    noborder: true
  },
  {
    label: '病历照片',
    prop: 'prescriptionPicUrls',
    class: 'large',
    type: 'img',
    nopadding: true,
    noborder: true
  },
  {
    label: '检查检验单',
    prop: 'checkList',
    class: 'large',
    type: 'img',
    nopadding: true,
    noborder: true
  }
]

// 活动信息
const columnTable = [
  {
    title: '临观活动名称',
    dataIndex: 'activityTemplateName',
    key: 'activityTemplateName',
    width: 300,
    slots: { customRender: 'activityTemplateName' }
  },
  {
    dataIndex: 'cureStatus',
    key: 'cureStatus',
    title: '治疗状态',
    width: 180,
    customRender: ({ text }) => {
      // 0 待判定 1 治疗中 2治愈 3失访 4无效 5 有效
      if (!text) return '待判定'
      const status = ['待判定', '治疗中', '治愈', '失访', '无效', '有效']
      const ans = status[text]
      return ans
    }
  },
  {
    dataIndex: 'assertCureName',
    width: 180,
    key: 'assertCureName',
    title: '判定人'
  },
  {
    dataIndex: 'assertCureTime',
    key: 'assertCureTime',
    width: 180,
    title: '判定时间'
  },
  {
    dataIndex: 'accountStatus',
    key: 'accountStatus',
    width: 180,
    title: '结算状态',
    customRender: ({ text }) => {
      if (!text) return '待判定'
      const status = ['待判定', '待结算', '不结算', '线上结算', '线下结算']
      const ans = status[text]
      return ans
    }
  },
  {
    dataIndex: 'assertAccountName',
    key: 'assertAccountName',
    ellipsis: true,
    width: 180,
    title: '确定结算人'
  },
  {
    width: 180,
    dataIndex: 'assertAccountTime',
    key: 'assertAccountTime',
    title: '确定结算时间'
  }
]
export { BASE_LABEL, columnTable }
